<template>
  <header class="header">
    <Nav></Nav>
    <div class="content">
      <h3>成就客户是我们的荣耀</h3>
      <p>用心交付每一份信任</p>
    </div>
  </header>
  <div class="wanke">
    <div class="top">
     <img
        src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/vankelogo.png"
        alt=""
      />
	  <!-- <img src="../assets/img/appbj.jpg" alt=""> -->
      <div class="content">
        <h3>万科集团</h3>
        <p>
          万科企业股份有限公司成立于1984年，经过三十余年的发展，已成为国内领先的城乡建设与生活服务商，公司业务聚焦全国经济最具活力的三大经济圈及中西部重点城市。
        </p>
        <span>小程序设计开发</span>
        <span>系统安全运维</span>
        <P class="duan">手机端应用展示</P>
      </div>
    </div>
    <div class="bottom">
      <img
        src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/vanke.png"
        alt=""
      />
    </div>
  </div>
  <div class="wanke">
    <div class="top">
      <img
        src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/hangtianlogo.png"
        alt=""
      />
      <div class="content">
        <h3>航田产业园</h3>
        <p>
          作为助力航空港实验区建设的科学探索者，航田公司集产业园区综合开发、园区运营、产业服务为一体，立足航空港，深耕产业经济:联合政府，整合优势产业链、渠道发展、服务政策、金融资本多维体系，打造闭合全产业链生态体系，实现产城融合。
        </p>
        <span>小程序设计开发</span>
        <span>系统安全运维</span>
        <P class="duan">手机端应用展示</P>
      </div>
    </div>
    <div class="bottom">
      <img
        src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/hangtain.png"
        alt=""
      />
    </div>
  </div>
  <div class="wanke">
    <div class="top">
      <img
        src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/guowanglogo.png"
        alt=""
      />
      <div class="content">
        <h3>国网广汇建设系统</h3>
        <p>
          国网广汇建设系统是国网广汇公司内部使用的建设系统，项目开发了国网广汇建设管理系统和国网广汇小程序，用于各个部门的任务派发操作及审批流程，便于统一进行处理，文件存储及文案归档多种不同的形式，也便于项目管理处对这些项目的时间把控及处理。(此处说明:页面展示仅为设计文件，内容关乎企业内部信息这里都进行了隐藏，具体内容请以实际上线效果为准)
        </p>
        <span>充电桩项目管理系统</span>
        <span>多语言网站设计开发</span>
        <span>多语言网站设计开发</span>
        <P class="duan">PC端应用展示</P>
      </div>
    </div>
    <div class="bottom">
      <img
        src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/guowang.png"
        alt=""
      />
    </div>
  </div>

  <div class="wanke">
    <div class="top">
      <img
        src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/jinjianglogo.png"
        alt=""
      />
      <div class="content">
        <h3>锦江国际集团</h3>
        <p>
          中国(上海)国际酒店投资加盟与特许经营展览会”秉承推广优质、专业的连锁酒店、度假村、公寓、精品酒店、民宿品牌，并邀约开发商、投资商、业主方进行业务对接，打造专属的投资加盟线下平台。
        </p>
        <span>小程序设计开发</span>
        <span>系统安全运维</span>
        <P class="duan">手机端应用展示</P>
      </div>
    </div>
    <div class="bottom">
      <img
        class="jinjiang"
        src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/jinjiang.png"
        alt=""
      />
    </div>
  </div>

  <div class="wanke">
    <div class="top">
      <img
        src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/weilianlogo.png"
        alt=""
      />
      <div class="content">
        <h3>威廉管家</h3>
        <p>
          中国(上海)威廉是一家会员制高端家庭服务品牌，打造家庭事务的酒店化管理，让您有时间享受生活而不是处理家庭琐事。以西方管家文化头企业文化根基，人格平等、职业的自豪感在员工入职的那一刻就深深烙印在员工意识中，职业化、忠诚、绅士是威廉对每一个员工的基础评价标准。
        </p>
        <span>小程序设计开发</span>
        <span>系统安全运维</span>
        <P class="duan">手机端应用展示</P>
      </div>
    </div>
    <div class="bottom">
      <img
        src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/weilian.png"
        alt=""
      />
    </div>
  </div>

  <div class="wanke">
    <div class="top">
      <img
        src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/zhongjianlogo.png"
        alt=""
      />
      <div class="content">
        <h3>中建七局</h3>
        <p>
          中建七局隶属于世界500强第37位(2015年排名)、全球最大的住宅工程建造商，中国最具国际竞争力的建筑企业集团。中建七局注重员工的健康活动建设与文化活动的建设，不定期举行
          篮球赛，足球赛等体育赛事活动，但在疫情期间，因疫情原因，导致线下的各种活动取消，君和数字为中建七局多名员工打造线上员工活动平台，实现在线运动排名，在线答题，在线学习等综合性平台，为中建七局员工提供线上的活动平台，增进员工活动活跃度，提升员工健康和职业技能。
        </p>
        <span>小程序设计开发</span>
        <span>系统安全运维</span>
        <P class="duan">手机端应用展示</P>
      </div>
    </div>
    <div class="bottom">
      <img
        src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/zhongjian.png"
        alt=""
      />
    </div>
  </div>

  <div class="wanke">
    <div class="top">
      <img
        src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/zhongjiaologo.png"
        alt=""
      />
      <div class="content">
        <h3>中交一公局</h3>
        <p>
          中交一公局坚持“以人为本、科技兴企”的经营理念，以技术创新、管理创新作为支撑点，以争创一流作为企业可持续发展的新动力，创建出一大批国家级精品工程，
          同时，中交一公局注重产品结构上的不断优化，使企业的经营规模和经济运行质量都实现了新的突破和飞跃。
        </p>
        <span>小程序设计开发</span>
        <span>系统安全运维</span>
        <P class="duan">手机端应用展示</P>
      </div>
    </div>
    <div class="bottom">
      <img
        src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/zhongjiao.png"
        alt=""
      />
    </div>
  </div>
  <div class="wanke">
    <div class="top">
      <img
        src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/buyaologo.png"
        alt=""
      />
      <div class="content">
        <h3>浦耀集团</h3>
        <p>
          上海浦耀贸易有限公司成立于1998年，主要从事大宗农产品原料贸易，目前经营品种有豆粕、玉米、油脂等，业务布局覆盖全国，建立了华东、华中、华南、鲁豫、华北、东北等成熟的业务范围，通过“贸易+供应链+互联网”的模式，提升大宗农产品在交易与流通环节的安全与效率。
        </p>
        <span>小程序设计开发</span>
        <span>系统安全运维</span>
        <P class="duan">手机端应用展示</P>
      </div>
    </div>
    <div class="bottom">
      <img
        class="puyao"
        src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/buyao.png"
        alt=""
      />
    </div>
  </div>

  <div class="wanke">
    <div class="top">
      <img
        src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/dukanglogo.png"
        alt=""
      />
      <div class="content">
        <h3>杜康控股集团</h3>
        <p>
          杜康控股集团是一家以酒业为主导产业，集研发、生产、经营、销售、管理于一体的综合性控股公司。杜康控股有限公司所拥有的“杜康”商标被评为中国驰名商标。
        </p>
        <span>小程序设计开发</span>
        <span>系统安全运维</span>
        <span>代理商管理</span>
        <P class="duan">手机端应用展示</P>
      </div>
    </div>
    <div class="bottom">
      <img
        src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/dukang.png"
        alt=""
      />
    </div>
  </div>

  <div class="wanke">
    <div class="top">
      <img
        src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/xinyuanlogo.png"
        alt=""
      />
      <div class="content">
        <h3>鑫苑物业</h3>
        <p>
          “创造经典，至于至善”鑫苑集团认真践行企业人格，聚焦业务，彰显新发优势，面向国内及北美房地产市场，以国际化的战略思路和实践，不断奋发，成长为中国房地产业最有价值和影响力的国际化公众公司！
        </p>
        <span>小程序设计开发</span>
        <span>系统安全运维</span>
        <P class="duan">手机端应用展示</P>
      </div>
    </div>
    <div class="bottom">
      <img
        src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/xinyuan.png"
        alt=""
      />
    </div>
  </div>

<!--  <div class="wanke">
    <div class="top">
      <img
        src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/jianyelogo.png"
        alt=""
      />
      <div class="content">
        <h3>建业教育</h3>
        <p>
          建业教育始创于1996年，坚守“一切为了孩子”的初心和“教育，让生命更美好”的使命，秉承“精品教育，奉献社会”的办学宗旨，致力于培养具备民族情怀、国际视野、领袖气质的可持续发展的现代中国人。
        </p>
        <span>小程序设计开发</span>
        <span>系统安全运维</span>
        <P class="duan">手机端应用展示</P>
      </div>
    </div>
    <div class="bottom">
      <img
        src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/jianye.png"
        alt=""
      />
    </div>
  </div> -->

  <div class="wanke">
    <div class="top">
      <img
        src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/yinlilogo.png"
        alt=""
      />
      <div class="content">
        <h3>饮力实验室</h3>
        <p>
          饮力实验室站在门店使用需求角度，深度测评水精灵爆打柠檬机捯压出的柠檬风味、稳定性、效率等情况。结合其产品研发思路，进行原料基础解析，并与不同类型茶叶、水果搭配，测评其应用匹配度，给这一新型产品提出明确的应用方向和建议。
        </p>
        <span>小程序设计开发</span>
        <span>系统安全运维</span>
        <P class="duan">手机端应用展示</P>
      </div>
    </div>
    <div class="bottom">
      <img
        src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/yinli.png"
        alt=""
      />
    </div>
  </div>

  <div class="wanke">
    <div class="top">
      <img
        src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/aopulogo.png"
        alt=""
      />
      <div class="content">
        <h3>澳葡国际集团</h3>
        <p>
          澳葡国际集团是央企中石油昆仑好客海外唯一中国品牌出口商和进口产品供应商。公司下设澳葡严选供应链(珠海)有限公司，澳银国际食品进出口(深圳)有限公司等全资公司，拥有庞大的客户群体，利用现有的客户资源，以及抖音平台的流量开发一个线上商城，用户可通过微信小程序、抖音小程序以及H5商城进行下单购买商品。
        </p>
        <span>小程序设计开发</span>
        <span>系统安全运维</span>
        <P class="duan">手机端应用展示</P>
      </div>
    </div>
    <div class="bottom">
      <img
        src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/aopu.png"
        alt=""
      />
    </div>
  </div>
  <div class="wanke">
    <div class="top">
      <img
        src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/antulogo.png"
        alt=""
      />
      <div class="content">
        <h3>安图生物</h3>
        <p>
          安图生物创立于1998年，专注于体外诊断试剂和仪器的研发、制造、整合及服务，产品涵盖免疫、微生物、生化等检测领域，同时也在分子检测等领域积极布局，能够为医学实验室提供全面的产品解决方案和整体服务。公司于2016年9月1日在上海证券交易所挂牌上市，是国内第一家在主板上市的体外诊断生产企业。
        </p>
        <span>小程序设计开发</span>
        <span>系统安全运维</span>
        <span>响应式网站</span>
        <P class="duan">PC端应用展示</P>
      </div>
    </div>
    <div class="bottom">
      <img
        class="antu"
        src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/antu.png"
        alt=""
      />
    </div>
  </div>
  <div class="kefu">
    <h3>这只是开始，我们每天都在进步</h3>
<!--    <button @click="toConsult">
      联系客服，查看更多案例 -->
	  <a href="https://wt.zoosnet.net/LR/Chatpre.aspx?id=LRW51906172&lng=cn" target="_blank">联系客服，查看更多案例
      <img
        src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/kefubt.png"
        alt=""
      />
	  </a>
<!--    </button> -->
  </div>
  <Footer></Footer>
  <Floating></Floating>
  <Onlineservice></Onlineservice>
</template>

<script>
import Nav from "./Nav.vue";
import Footer from "./Footer.vue";
import Onlineservice from "./Onlineservice.vue";
import Floating from "./Floating.vue";
export default {
  name: "case",
  components: {
    Nav,
    Footer,
    Floating,
    Onlineservice,
  },
  methods: {
    // toConsult() {
    //   window.open(
    //     "https://wt.zoosnet.net/LR/Chatpre.aspx?id=LRW51906172&lng=cn&e=%e5%bc%b9%e7%aa%97",
    //     "_blank"
    //   );
    // },
  },
  created() {
      window.scrollTo(0, 0);
  },
};
</script>

<style lang="less" scoped>
.header {
  width: 100%;
  height: 520px;
  background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/casebanner.png)
    no-repeat;
  background-size: cover;
  .content {
    width: 1440px;
    height: 400px;
    margin: 0 auto;
    /* background-color: white; */
    overflow: hidden;
    color: white;

    h3 {
      height: 50px;
      line-height: 50px;
      font-size: 36px;
      margin-top: 100px;
      font-weight: 540;
    }
    p {
      height: 50px;
      line-height: 50px;
      font-size: 22px;
      margin-top: 20px;
      font-weight: 400;
    }
  }
}
.wanke {
  width: 1440px;
  height: 1100px;
  margin: 0 auto;
  //   background: #eee;
  border-bottom: 1px solid #efefef;
  .top {
    height: 200px;
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    // background: #fe1;
    img {
      display: block;
      width: 110px;
      height: 110px;
    }
    .content {
      width: 1300px;
      position: relative;
      // height: 200px;
      h3 {
        // width: 120px;
        height: 30px;
        font-size: 20px;
        font-weight: 500;
        line-height: 30px;
        color: #333333;
        margin-top: 50px;
        opacity: 1;
      }
      p {
        width: 1300px;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        color: #666666;
        opacity: 1;
        margin-top: 10px;
        margin-bottom: 20px;
      }
      span {
        display: inline-block;
        padding: 0 10px;
        height: 30px;
        border: 1px solid #e71115;
        opacity: 1;
        border-radius: 15px;
        font-size: 12px;
        font-weight: 500;
        line-height: 30px;
        color: #e71115;
        text-align: center;
        margin: 0 20px 0 0;
      }
      .duan {
        position: absolute;
        width: 100%;
        height: 20px;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        color: #333333;
        opacity: 1;
        bottom: -100px;
      }
    }
  }
  .bottom {
    position: relative;
    margin-top: 80px;
    p {
      width: 1000px;
      height: 20px;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      color: #333333;
      opacity: 1;
      margin-left: 130px;
      margin-top: -60px;
    }
    img {
      display: block;
      width: 1360px;
      height: 832px;
      margin: 0 auto;
    }
    .antu {
      width: 1440px;
      height: 667px;
    }
    .puyao {
      width: 1142px;
      height: 818px;
    }
    .jinjiang {
      padding-top: 60px;
      width: 1240px;
      height: 748px;
    }
  }
}
.kefu {
  width: 100%;
  height: 500px;
  background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/app/static/kefubg.png)
    no-repeat;
  background-size: cover;
  overflow: hidden;
  h3 {
    width: 600px;
    height: 50px;
    font-size: 36px;
    font-weight: bold;
    line-height: 50px;
    color: #333333;
    opacity: 1;
    margin: 0 auto;
    margin-top: 200px;
    text-align: center;
  }
  a {
    position: relative;
    display: block;
    width: 400px;
    height: 70px;
    background: #e71115;
    opacity: 1;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 400;
    line-height: 70px;
    color: #ffffff;
    text-align: center;
    margin: 0 auto;
    margin-top: 60px;
	text-align: center;
	line-height: 70px;
    img {
      display: block;
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto;
      left: 300px;
      width: 30px;
      height: 28px;
    }
  }
}
</style>